import { BaseSvgIcon } from './BaseSvgIcon'

export const FeedBottleIcon = (props: any) => {
  const { width = 80, height = 80, ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 80 80" fill="none" {...rest}>
      <mask
        id="mask0_404_272"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M0 0H80V80H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_404_272)">
        <path
          d="M75.8573 9.79835L77.6568 7.99882C79.2185 6.4371 79.2185 3.90507 77.6568 2.34319C76.0951 0.781477 73.563 0.781477 72.0013 2.34319L70.2018 4.14288C67.487 6.85773 63.2949 7.42898 59.9526 5.53991C56.6102 3.6507 52.4182 4.2221 49.7034 6.93694L48.4821 8.1582L71.842 31.5179L73.0632 30.2966C75.778 27.5819 76.3495 23.3899 74.4602 20.0476C72.571 16.7051 73.1424 12.5132 75.8573 9.79835Z"
          fill="#FFF2B4"
        />
        <path
          d="M61.4796 14.0678C63.4368 12.1106 66.6101 12.1106 68.5674 14.0678L74.359 19.8593C72.5948 16.549 73.193 12.4626 75.8573 9.79839L77.6568 7.9987C79.2185 6.43699 79.2185 3.90495 77.6568 2.34324C76.0951 0.781515 73.563 0.781515 72.0013 2.34324L70.2018 4.14277C67.487 6.85761 63.2949 7.42902 59.9526 5.5398C56.6101 3.65058 52.4182 4.22198 49.7034 6.93683L48.4821 8.15808L61.4796 21.1556C59.5224 19.1982 59.5224 16.025 61.4796 14.0678Z"
          fill="#FFDF8E"
        />
        <path
          d="M63.2302 38.9002L41.0999 16.7699C38.3838 14.0538 38.3838 9.65019 41.0999 6.93409C43.816 4.21815 48.2196 4.21815 50.9355 6.93409L73.066 29.0644C75.7819 31.7805 75.7819 36.1841 73.066 38.9002H73.0658C70.3499 41.6163 65.9463 41.6163 63.2302 38.9002Z"
          fill="#B0D8FD"
        />
        <path
          d="M49.9387 15.773C52.6548 13.0569 57.0584 13.0569 59.7745 15.773L50.9356 6.93408C48.2195 4.21814 43.8159 4.21814 41.0999 6.93408C38.384 9.65017 38.3839 14.0538 41.0998 16.7699L49.9387 25.6088C47.2226 22.8927 47.2226 18.4891 49.9387 15.773Z"
          fill="#9CCEFD"
        />
        <path
          d="M66.8139 50.2452C67.8311 49.228 68.3644 48.0278 68.6129 46.8459C69.165 44.2175 68.2802 41.4912 66.381 39.592L40.4079 13.6189C38.5086 11.7197 35.7826 10.835 33.154 11.3872C31.9721 11.6355 30.7719 12.1689 29.7549 13.1861C26.3643 16.5766 24.355 21.9762 18.1391 28.1922C11.9232 34.4081 6.52349 36.4173 3.13302 39.8078C2.11583 40.825 1.58239 42.0252 1.33411 43.207C0.781925 45.8355 1.66677 48.5617 3.56599 50.4609L29.5391 76.4341C31.4383 78.3333 34.1644 79.2181 36.793 78.6658C37.9747 78.4175 39.175 77.8841 40.1921 76.867C43.5827 73.4764 45.5918 68.0767 51.8079 61.8608C58.0236 55.6448 63.4235 53.6356 66.8139 50.2452Z"
          fill="#F7F0EB"
        />
        <path
          d="M10.173 52.0459C10.4213 50.864 10.9548 49.6639 11.9719 48.6467C15.3624 45.2562 20.7621 43.247 26.978 37.0311C33.194 30.8151 35.2032 25.4154 38.5937 22.025C39.6108 21.0078 40.811 20.4743 41.9929 20.2261C44.6213 19.6739 47.3476 20.5586 49.2468 22.4578L40.4079 13.619C38.5087 11.7198 35.7826 10.835 33.154 11.3873C31.9723 11.6356 30.7719 12.1689 29.7549 13.1861C26.3643 16.5767 24.3551 21.9764 18.1391 28.1923C11.9232 34.4082 6.5235 36.4175 3.13303 39.8079C2.11585 40.8251 1.58257 42.0253 1.33413 43.207C0.78194 45.8356 1.66678 48.5618 3.566 50.4611L12.4048 59.2998C10.5055 57.4006 9.62069 54.6745 10.173 52.0459Z"
          fill="#EFE2DD"
        />
        <path
          d="M28.3947 39.9532C26.8965 41.4514 24.1566 41.1408 22.275 39.2594C20.3936 37.3778 20.083 34.638 21.5813 33.1397C23.0796 31.6414 25.8194 31.9521 27.701 33.8336C29.5824 35.715 29.893 38.4549 28.3947 39.9532Z"
          fill="#FDA0C1"
        />
        <path
          d="M40.0468 51.6053C38.5486 53.1036 38.8592 55.8434 40.7406 57.725C42.6222 59.6064 45.362 59.917 46.8603 58.4187C48.3586 56.9205 48.0479 54.1806 46.1664 52.299C44.285 50.4176 41.5451 50.107 40.0468 51.6053Z"
          fill="#FDA0C1"
        />
        <path
          d="M30.9442 34.5611L29.6184 35.8869"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.9631 41.2155C34.8945 42.2132 35.2406 43.2339 36.0034 43.9967C36.766 44.7594 37.7868 45.1055 38.7845 45.0369"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.8695 49.0642C43.7181 48.2156 45.0939 48.2156 45.9423 49.0642C46.7909 49.9127 46.7909 51.2885 45.9423 52.137"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.7579 29.5115C75.8623 26.8176 76.1756 23.0823 74.4603 20.0474C72.5711 16.7051 73.1425 12.513 75.8573 9.79819L77.6568 7.99866C79.2186 6.43694 79.2186 3.90491 77.6568 2.34319C76.0951 0.781472 73.5631 0.781472 72.0014 2.34319L70.2017 4.14272C67.4868 6.85757 63.295 7.42897 59.9526 5.53975C56.9165 3.82366 53.1793 4.13788 50.4853 6.24475"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.4795 25.4782L73.0659 29.0646C75.782 31.7807 75.782 36.1842 73.0659 38.9002C71.6219 40.3442 69.7009 41.0205 67.8101 40.9291"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.0697 12.1622C38.9862 10.2803 39.663 8.37106 41.0998 6.93419C43.8159 4.21809 48.2195 4.21809 50.9356 6.93419L66.1656 22.1642"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0264 34.7579C7.28389 36.6065 4.92717 38.0139 3.13295 39.8079C2.11592 40.8251 1.58248 42.0253 1.3342 43.2071C0.78186 45.8356 1.6667 48.5618 3.56592 50.4611L29.5391 76.4342C31.4383 78.3334 34.1645 79.2181 36.793 78.6659C37.9748 78.4176 39.175 77.8842 40.1922 76.867C43.5826 73.4765 45.5919 68.0768 51.8078 61.8609C58.0237 55.645 63.4234 53.6357 66.8139 50.2453C67.8311 49.2281 68.3645 48.0279 68.6128 46.8461C69.165 44.2176 68.2803 41.4914 66.3811 39.5921L40.408 13.619C38.5087 11.7198 35.7825 10.835 33.1541 11.3873C31.9722 11.6356 30.772 12.1689 29.7548 13.1861C26.3644 16.5767 24.3551 21.9764 18.1392 28.1923C16.6948 29.6365 15.2947 30.8539 13.9534 31.914"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseSvgIcon>
  )
}
